export enum WebsocketEventType {
  aiChatUnreadMessage = 'AiChatUnreadMessage',
  customAiChatCreated = 'CustomAiChatCreated',
  customAiChatAvatarCreated = 'CustomAiChatAvatarCreated',
}
